<template>
  <base-material-card color="primary" icon="mdi-table" inline class="px-5 py-3">
    <template v-slot:after-heading>
      <div class="d-flex">
        <div class="mr-1">
          {{ selectedTable ? `TABELA :: ${selectedTable}` : '' }}
        </div>

        <v-progress-circular v-if="loadingCountRows" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />

        <div v-else-if="selectedTable" class="display-1 font-weight">:: {{ countRows | parseNumberToIntegerBR }} LINHAS</div>
      </div>
    </template>

    <v-row class="mx-auto my-8" align="center" no-gutters>
      <v-col v-if="!selectedTable" cols="12">
        <v-alert dense outlined type="info" color="blue" class="mb-0 px-1 py-1">
          Selecione uma tabela ao lado para poder realizar as consultas
        </v-alert>
      </v-col>
      <v-col v-else cols="12">
        <v-textarea
          v-model="querySql"
          class="mx-4 ta-padding-c"
          :disabled="loadingExecQuery"
          rows="10"
          no-resize
          background-color="#EEEEEE"
          placeholder="Escreva aqui sua consulta SQL"
          hint="Não insira ';' (ponto e vírgula) no final da query"
        />
      </v-col>
    </v-row>

    <div v-if="selectedTable" class="d-flex justify-end">
      <v-btn color="success" min-width="100" @click="dialogSaveData = true">Extrair</v-btn>
      <v-btn color="primary" min-width="100" :loading="loadingExecQuery" @click="getQueryData">Executar</v-btn>
    </div>

    <dialog-save-data-bdgd
      :table="selectedTable"
      :params="parametros"
      :dialog="dialogSaveData"
      @update:dialog="dialogSaveData = $event"
    />
  </base-material-card>
</template>

<script>
  import ExtracoesBdgdService from '@/services/ExtracoesBdgdService';
  import DialogSaveDataBdgd from './DialogSaveDataBdgd.vue';

  export default {
    name: 'ExtracoesBdgdExecutarQuery',

    components: { DialogSaveDataBdgd },

    props: {
      selectedTable: {
        type: String,
        default: () => null
      },
      bdgdId: {
        type: [Number, String],
        default: () => null
      },
      tables: {
        type: Array,
        default: () => []
      },
      active: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        headers: [],
        queryData: [],
        errorSql: null,
        pathTable: null,
        querySql: null,
        countRows: null,
        loadingExecQuery: false,
        loadingCountRows: false,
        dialogSaveData: false
      };
    },

    computed: {
      parametros() {
        return {
          bdgdId: this.bdgdId,
          query: this.querySql,
          tabela: this.pathTable
        };
      }
    },

    methods: {
      emitData() {
        this.$emit('update-values', {
          headers: this.headers,
          queryData: this.queryData,
          loading: this.loadingExecQuery,
          error: this.errorSql,
          recharge: true
        });
      },

      getQueryData() {
        this.loadingExecQuery = true;
        this.errorSql = null;
        this.queryData = [];
        this.headers = [];

        return ExtracoesBdgdService.getQueryData(this.bdgdId, this.querySql)
          .then(({ data }) => {
            this.queryData = data;
            this.headers =
              data.length === 0
                ? []
                : Object.keys(data[0]).map((key) => ({
                    text: key,
                    value: key
                  }));
          })
          .catch((err) => {
            this.errorSql = err.data?.error ?? 'Erro desconhecido';
            this.$toast.error('Erro ao buscar os dados da tabela.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loadingExecQuery = false));
      },

      getCountRows(pathTable) {
        this.loadingCountRows = true;

        return ExtracoesBdgdService.getCountRows(this.bdgdId, pathTable)
          .then(({ data }) => {
            this.countRows = data[0].linhas;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao buscar a quantidade de linhas da tabela.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loadingCountRows = false));
      }
    },

    watch: {
      selectedTable(newTable) {
        if (!newTable) return;

        const selected = this.active.length ? this.active[0] : null;
        const item = this.tables[selected];

        if (!item) return;

        this.pathTable = `${item.path}.${item.tabela}`;
        this.querySql = `SELECT * FROM ${item.path}.${item.tabela}`;

        this.getQueryData();
        this.getCountRows(this.pathTable);
      },
      headers() {
        this.emitData();
      },
      queryData() {
        this.emitData();
      },
      loadingExecQuery() {
        this.emitData();
      },
      errorSql() {
        this.emitData();
      },
      dialogSaveData() {
        this.emitData();
      }
    }
  };
</script>
